import {
  DEVICE_STATISTICS_CHANGE
} from "../constants/ActionTypes";

const now = new Date();

const INIT_STATE = {
  value:{
      startTime:new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0,0),
      endTime:new Date(now.getFullYear(),now.getMonth(),now.getDate(),23,59,59),
      team:0,
      shift:0
  }
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case DEVICE_STATISTICS_CHANGE:
      return {...state,value:action.payload};
    default:
      return state;
  }
}
